/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { AuditableEntity } from "./auditable-entity";

export class CmpTaskBase extends AuditableEntity {
    number: string = undefined;
    shortDescription: string = undefined;
    description: string = undefined;
    taskVariablesId: string = undefined;
    assignedToId: string = undefined;
    assignmentGroupId: string = undefined;
    openedOn: Date = undefined;
    dueDate: Date = undefined;
    openedById: string = undefined;
    closedOn: Date = undefined;
    closedById: string = undefined;
    active: boolean = undefined;
    taskStateId: string = undefined;
    taskTypeId: string = undefined;
    parentId: string = undefined;
    taskKey: string = undefined;
    taskId: string = undefined;
}
